module.exports = __webpack_public_path__ + "static/img/2.6513a80.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/eng/2.png
// module id = XYT4
// module chunks = 0